import atoms from "../../../atoms";
import { RiDeleteBin6Line } from "react-icons/ri";
import { StoreStaffColumnProps, StoreStaffListProps, ViewStoreStaffProps } from "./interface";

const { Table, Button,Search } = atoms

const Index = ({ storeStaffList, handleDeleteStaff,handleSearch }: ViewStoreStaffProps) => {
    const columns = [
        { name: 'S.No', selector: (row: StoreStaffColumnProps) => row.index_number },
        { name: 'User Name', selector: (row: StoreStaffColumnProps) => row?.user?.username ?? '-', },
        { name: 'Email', selector: (row: StoreStaffColumnProps) => row?.user?.email ?? '-', },
        { name: 'Action', selector: (row: StoreStaffColumnProps) => row.action, },
    ]

    return (
        <>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search searchCallBack={(e: string) => handleSearch(e)} />
                </div>
                <div className="col-6"></div>
            </div>
            {storeStaffList?.length > 0 ? <Table
                AdditionalClassName="add-invertory-table"
                columns={columns}
                data={storeStaffList?.map((item: StoreStaffListProps, index: number) => {
                    return ({
                        ...item,
                        index_number: index + 1,
                        action:
                            <Button className="table-delete-button fs-14 fw-400 ms-3"
                                onClick={() => handleDeleteStaff(item?.id)}>
                                <div className='d-flex align-items-center'>
                                    <RiDeleteBin6Line />
                                    <span className='ms-2 mb-0'>Delete</span>
                                </div>
                            </Button>

                    })
                })}
            /> : <div className='justify-content-center d-flex mt-5 '>There are no records to display</div> }
        </>
    )
}

export default Index